<!--@format-->
<template>
    <component
        :is="`${element.name}`"
        v-if="element"
        ref="contentElement"
        class="document-type-element"
        :element="element"
        @close="closePopup"
    />
</template>

<script>
import Vue from 'vue';
import RecipientElementPopup from '@/components/popups/popup-elements/document-builder/recipient-element-popup';
import ReviewAndSignPopup from '@/components/popups/popup-elements/document-builder/review-and-sign-popup';
import VoidDocument from '@/components/popups/popup-elements/document-builder/void-document-popup';
import DeclineToSign from '@/components/popups/popup-elements/document-builder/decline-to-sign-popup';
import ManageDocumentApprovalPopup from '@/components/popups/popup-elements/document-builder/manage-document-approval-popup';
import LinkOpportunityPopup from '@/components/popups/popup-elements/document-builder/link-opportunity-popup';
import IntegrationPopup from '@/components/popups/popup-elements/integration/integration-enable-disable-popup';
import SuccessAnimationPopup from '@/components/popups/popup-elements/commons/success-animation-popup';
import LoadingAnimationPopup from '@/components/popups/popup-elements/commons/loading-animation-popup';
import UserReauthenticatedPopup from '@/components/popups/user-reauthenticated-popup';
import InvoicePreviewPopup from '@/components/popups/popup-elements/invoice-preview-popup';
import AppUserAuthorizePopup from '@/components/common/app-user-authorize-popup.vue';

Vue.component(RecipientElementPopup.name, RecipientElementPopup);
Vue.component(ReviewAndSignPopup.name, ReviewAndSignPopup);
Vue.component(VoidDocument.name, VoidDocument);
Vue.component(DeclineToSign.name, DeclineToSign);
Vue.component(ManageDocumentApprovalPopup.name, ManageDocumentApprovalPopup);
Vue.component(LinkOpportunityPopup.name, LinkOpportunityPopup);
Vue.component(IntegrationPopup.name, IntegrationPopup);
Vue.component(SuccessAnimationPopup.name, SuccessAnimationPopup);
Vue.component(LoadingAnimationPopup.name, LoadingAnimationPopup);
Vue.component(UserReauthenticatedPopup.name, UserReauthenticatedPopup);
Vue.component(InvoicePreviewPopup.name, InvoicePreviewPopup);
Vue.component(AppUserAuthorizePopup.name, AppUserAuthorizePopup);

export default {
    props: {
        element: {
            type: Object,
            required: true,
        },
    },

    methods: {
        closePopup() {
            this.$emit('close');
        },
    },
};
</script>
